// React Query configuration
import type { QueryClientConfig } from "@tanstack/react-query";

export const reactQueryConfig: QueryClientConfig = {
  defaultOptions: {
    queries: {
      networkMode: globalThis.window?.env?.isElectron ? "always" : "online",
      refetchOnWindowFocus: false,
      retry: false,
      gcTime: 0,
      staleTime: 0,
    },
    mutations: {
      networkMode: globalThis.window?.env?.isElectron ? "always" : "online",
    },
  },
};
